// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const cpr: CountryValidator<"BH"> = createValidator(
  "bh.cpr",
  24,
);

export default cpr;
export const compact = cpr.compact;
export const format = cpr.format;
export const validate = cpr.validate;
export const generate = (): string =>
  cpr.generate?.() ??
  (() => {
    throw new Error(
      "Validator bh.cpr cannot generate values",
    );
  })();
